
// import '@babel/polyfill';

// import barba from '@barba/core';

/* eslint-disable consistent-return */

import Rellax from 'rellax';

import device from 'current-device';

import {TimelineLite} from 'gsap';

import { Fancybox, Carousel } from "@fancyapps/ui";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm";


// import slick from 'slick-carousel';


import { formsInit } from './lib/forms';

import './lib/brief';
import './lib/header';
import './lib/fileupload';
import { Modal } from './lib/modal';

import { Modal2 } from './lib/modal2';

const modal = new Modal();

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});

const carousels = document.querySelectorAll(".f-carousel");

if (carousels){

  carousels.forEach(carousel => {
    
      // eslint-disable-next-line no-new
      new Carousel(carousel, {
        Autoplay: {
          timeout: 3000,
          showProgress: false
        },
        transition: "slide",
        slidesPerPage: 1,
        Dots: false,
      });
  })
}

// import easyScroll from 'easy-scroll';

// import fancybox from '@fancyapps/fancybox'; 

// import photoswipe from 'photoswipe';
// import Glide from '@glidejs/glide';

// import Smooth from 'smooth-scrolling';

console.log(device.type);

// polyfill for ie11 video object-fit
// require('objectFitPolyfill/dist/objectFitPolyfill.basic.min');


// sort language dom elements
const elements = document.querySelectorAll('.header_lang_switch .lang');

let i;
const itemsArr = [];
for (i = 0; i < elements.length; i++) { 
  if(elements[i].classList.contains('active')) {
    itemsArr.unshift(elements[i]);
  }else{
    itemsArr.push(elements[i]);
  }
}
const foo = document.getElementsByClassName('header_lang_switch')[0]; 
for (i = 0; i < itemsArr.length; ++i) {
  foo.appendChild(itemsArr[i]);
}

// end sort language dom elements



const home = document.querySelector('.home');
const projects = document.querySelector('.projects');
const contacts = document.querySelector('.contacts');
const single = document.querySelector('.single');
const aboutus = document.querySelector('.aboutus');


document.addEventListener('DOMContentLoaded', function() {

  formsInit();


  if (home) {


    document.documentElement.classList.add('h100');

    if (device.type !== 'desktop') {

      // var hero = document.querySelector('.hero');

      // var y,div;






          
      
      // if (slider) {
      //   $.each(slider.img, function() {
      //     y = document.createElement('div');
      //     y.className = '';
      //     y.innerHTML = '<img src=" '+ this['url']+'" />';
      //     hero.appendChild(y);
      //   });     
      // }else{

      //   $.each(slider.img, function() {
      //     y = document.createElement('div');
      //     y.className = '';
      //     y.innerHTML = '<img src=" '+ this['url']+'" />';
      //     hero.appendChild(y);
      //   });

      // }

      // $('.hero').slick({
      //   infinite: true,
      //   slidesToShow: 3,
      //   slidesToScroll: 3,
      //   dots: false,
      //   arrows: false,
      //   draggable: false,
      //   autoplay: true,
      //   cssEase: 'ease',
      //   autoplaySpeed: 5000,
      //   speed: 1000
      // });

      window.onload = function() {
        document.body.classList.add('loaded');
      };      
    }

    if (device.type === 'desktop') {

      // var hero = document.querySelector('.hero');
      // var x = document.createElement('video');

      // if (x.canPlayType('video/mp4')) {
      //   x.setAttribute('src',$('.hero_src').data('mp4'));
      // } else {
      //   x.setAttribute('src',$('.hero_src').data('ogv'));
      // }

      // x.autoplay = true;
      // x.loop = true;
      // x.muted = true;
      // // x.load();
      
      // objectFitPolyfill(x);
      
      // hero.appendChild(x);

      // x.oncanplaythrough = function() {
      //   document.body.classList.add('loaded');
      // };
      window.onload = function() {

        document.body.classList.add('loaded');
      };
      
    }
  }


  if (projects) {
    if (( device.type === 'desktop' ) && ( device.orientation === 'landscape' )) {
      const rx = document.querySelectorAll('.rellax');    
      if (rx) {
        $('.rellax').filter(':even').attr('data-rellax-speed','0');
        $('.rellax').filter(':odd').attr('data-rellax-speed','-1');
        window.onload = function() {
          const rellax = new Rellax('.rellax', {
            speed: 0,
            center: true,
            wrapper: null,
            round: false,
            vertical: true,
            horizontal: false,
            // callback: function(position) {
            //   // console.log(position);

            // }
          });
          document.body.classList.add('loaded');
        };
     
      }
    }else{
      document.body.classList.add('loaded');      
    }
  }

  if(single) {
    document.body.classList.add('loaded');
    // window.onload = function() {
    //   document.body.classList.add('loaded');
    // };
  }

  // if(contacts) {
  //   document.documentElement.classList.add('h100');
  //   document.body.classList.add('loaded');

  // }


  if (aboutus) {
    const hero = document.querySelector('.about_hero');

    if (device.type === 'desktop') {

      // var x = document.createElement('video');

      // x.autoplay = true;
      // x.loop = true;
      // x.muted = true;
      // x.src=$('.about_hero_src').data('mp4');
      // x.setAttribute('type','video/mp4');

      // hero.appendChild(x);
      // objectFitPolyfill(x);

      // x.oncanplaythrough = function() {
      //   document.body.classList.add('loaded');
      // };

      window.onload = function() {























        document.body.classList.add('loaded');
      };

    }else{

      // var y,div;



          
      
      // if (slider) {
      //   $.each(slider.img, function() {
      //     y = document.createElement('div');
      //     y.className = '';
      //     y.innerHTML = '<img src=" '+ this['url']+'" />';
      //     hero.appendChild(y);
      //   });     
      // }else{

      //   $.each(slider.img, function() {
      //     y = document.createElement('div');
      //     y.className = '';
      //     y.innerHTML = '<img src=" '+ this['url']+'" />';
      //     hero.appendChild(y);
      //   });

      // }

      // $('.about_hero').slick({
      //   infinite: true,
      //   slidesToShow: 3,
      //   slidesToScroll: 3,
      //   dots: false,
      //   arrows: false,
      //   draggable: false,
      //   autoplay: true,
      //   cssEase: 'ease',
      //   autoplaySpeed: 5000,
      //   speed: 1000
      // });



      window.onload = function() {
        document.body.classList.add('loaded');
      };    

    }
  }


  if ((!home)&&(!projects)&&(!single)&&(!aboutus)) {
    document.documentElement.classList.remove('h100');
    document.body.classList.add('loaded');
  }

  // /language stagger

  const tl = new TimelineLite().staggerFromTo('.header_lang_switch .lang a', 0.4, 
    {
      cycle:{
        
        y(index) { if (index >0 ) {return -50;}},
        opacity(index) { if (index >0 ) {return 0;}},
      },
      // ease: Power2.easeOut
    }
    ,{
      cycle:{
        y(index) { if (index >0 ) {return 0;}},
        opacity(index) { if (index >0 ) {return 1;}},
      },
      // ease: Power1.easeInOut
    }
    ,0.07
  ).reverse();


  $('.header_lang_switch').mouseenter(function() {
    if(!tl.isActive()) {
      tl.play();
    } else{
      tl.stop();
      tl.restart();
    }
  });

  $('.header_lang_switch').mouseleave(function() {
    if(!tl.isActive()) {
      tl.reverse(!tl.reversed());  
    } else{
      tl.stop();
      tl.reverse(!tl.reversed());  
    }
  });

  // create mobile menu
  setTimeout(function() {
    $('.header_main_menu').clone().removeClass('header_main_menu').addClass('header_overlay_main_menu').appendTo('.header_overlay');
    $('.header_lang_switch').clone().removeClass('header_lang_switch').addClass('header_overlay_lang_switch').appendTo('.header_overlay');
    if($('.header_overlay_lang_switch .lang a')) { $('.header_overlay_lang_switch .lang a').removeAttr('style');}
    $('.footer_documents').clone().removeClass('footer_documents').addClass('header_overlay_documents').appendTo('.header_overlay');
    $('.footer_socials').clone().removeClass('footer_socials').addClass('header_overlay_socials').appendTo('.header_overlay');
    $('.footer_exhibitslogo').clone().removeClass('footer_exhibitslogo').addClass('header_overlay_exhibitslogo').appendTo('.header_overlay');
    $('.footer_copyrights').clone().removeClass('footer_copyrights').addClass('header_overlay_copyrights').appendTo('.header_overlay');
  }, 1000);

  $(document).on('click','.header_menu_icon' ,function() {
    const hh = $('header').height();
    $('header').toggleClass('is-active');
    if ($('header').hasClass('is-active')) {
      $('main').css({'padding-top':hh});
    }else{
      $('main').css({'padding-top':0});
    }
    $('body').toggleClass('no-scroll');
  });

});


// modal prev next
let prevID; let nextID;

function prevnext(el) {
  $('.modal_prev').remove();
  $('.modal_next').remove();
  
  let x='';
  if ($(`#${  el}`).prev().length) {
    prevID = $(`#${  el}` ).prev().attr('id');
    x += `<div class="modal_prev" data-id=${prevID}></div>`;
    // console.log(prevID);
  }
  if ($(`#${ el}` ).next().length) {
    nextID = $(`#${  el}`).next().attr('id');
    x += `<div class="modal_next" data-id=${nextID}></div>`;
    // console.log(nextID);
  }

  // $( '.modal_body' ).after(function() {    
  //   return x;
  // });
  $( '.modal_body_wrap' ).append(x);
}




let prevnextA = true;

$(document).on('click', '.modal_next', function(e) { 
  e.preventDefault();
  e.stopPropagation();
  if (prevnextA === false) {return;}prevnextA = false;;
  $( '.modal_body_wrap' ).after(function() {
    return '<div class="modal_body_wrap"><div class="modal_body"><div class="modal_content"></div></div></div>';
  });
  const append = $('.modal_content').eq(1);
  $(`#${$(this).data('id')}`).clone().addClass('cloned').appendTo(append);
  prevnext($(this).data('id'));

  $('.modal_body_wrap').eq(0).addClass('modalOld');
  $('.modal_body_wrap').eq(1).addClass('modalNew');

  new TimelineLite().fromTo('.modalOld', 1, 
    {x:'0',opacity:1}, 
    {x:'-170%', opacity:0, onComplete() {$('.modalOld').remove(); prevnextA = true;}}
  ).fromTo('.modalNew', 1, 
    {x:'170%',opacity:0}, 
    {x:'0%', opacity:1, onComplete() {$('.modal_body_wrap').removeClass('modalNew'); }},
    '-=1'
  );  
});



$(document).on('click', '.modal_prev', function(e) { 
  e.preventDefault();
  e.stopPropagation();
  if (prevnextA === false) {return;}prevnextA = false;;
  $( '.modal_body_wrap' ).after(function() {
    return '<div class="modal_body_wrap"><div class="modal_body"><div class="modal_content"></div></div></div>';
  });
  const append = $('.modal_content').eq(1);
  $(`#${$(this).data('id')}`).clone().addClass('cloned').appendTo(append);
  prevnext($(this).data('id'));

  $('.modal_body_wrap').eq(0).addClass('modalOld');
  $('.modal_body_wrap').eq(1).addClass('modalNew');

  new TimelineLite().fromTo('.modalOld', 1, 
    {x:'0',opacity:1}, 
    {x:'170%', opacity:0, onComplete() {$('.modalOld').remove(); prevnextA = true; }}
  ).fromTo('.modalNew', 1, 
    {x:'-170%',opacity:0}, 
    {x:'0%', opacity:1, onComplete() {$('.modal_body_wrap').removeClass('modalNew'); }},
    '-=1'
  );
});

// end of modal prev next




// testimonials


$(document).on('click', '.testimonial_more', function(e) { 
  e.preventDefault();
  e.stopPropagation();
  // modalEmpty();
  modal.empty();

  $( this ).parents( '.testimonial' ).clone().addClass('cloned').appendTo('.modal_content');

  // modalActive();
  modal.active();
  prevnext($(this).data('id'));


  // console.log($(this).data('id'));
});

function generateURL(id) {
  const query = '?rel=0&showinfo=0&autoplay=1';

  return `https://www.youtube.com/embed/${  id  }${query}`;
}

function createIframe(id) {
  const iframe = document.createElement('iframe');

  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('allow', 'autoplay');
  iframe.setAttribute('src', generateURL(id));
  // iframe.classList.add('testimonial_video');

  return iframe;
}

$(document).on('click', '.video__button', function(event) { 
  event.preventDefault();
  event.stopPropagation();
  // modalEmpty();
  modal.empty();
  // console.log(window.innerWidth);
  if (window.innerWidth > 800) {
    // $( this ).parents( '.testimonial' ).clone().addClass('cloned').addClass('modal_content_data').appendTo('.modal_content');
    $( this ).parents( '.testimonial' ).clone().addClass('cloned').appendTo('.modal_content');

    setTimeout(function() {
      
      const iframe = createIframe($('.testimonial.cloned .video__button').data('yid'));

      iframe.style.height = `${$('.testimonial.cloned .testimonial_video__link').height() }px`;
      iframe.style.width = `${$('.testimonial.cloned .testimonial_video__link').width()  }px`;

      $('.testimonial.cloned .testimonial_video').append(iframe);
      prevnext($('.testimonial.cloned').attr('id'));
      $('.testimonial.cloned .testimonial_video__link').remove();  

      // $('.testimonial.cloned .testimonial_video__link').fadeOut();  

    }, 50);

    // modalActive();
    modal.active();



     

  }else{
    const iframe = createIframe($(this).data('yid'));
    $(this).parents('.testimonial_video').append(iframe);
    iframe.style.height = `${$(this).parents('.testimonial_video__link').height()  }px`;
    iframe.style.width = `${$(this).parents('.testimonial_video__link').width()  }px`;
    $(this).parents('.testimonial_video__link').remove();  
  }





});




// end of testimonials


// cookie
const cookie = document.querySelector('.cookie_modal');

function cookieClose() {
  cookie.classList.remove('active');
  $('.cookie_modal').css('opacity','0');
  setTimeout(function() {
    cookie.remove();
  }, 500);
}


// var single = document.querySelector('.single');

if(single) {
  if(cookie) {
    cookie.classList.remove('active');
  }
  // window.onscroll = function() {myFunction();};
  
}



function myFunction() {
  if (document.querySelector('.sticky_left')){
    return;
  }

  const header = document.querySelector('.single_header__details');
  const sticky = header.offsetTop;
  const border = document.querySelector('.single_header__details_wrap');
  const firstScreen = document.querySelector('.item__img');


  if (header.getBoundingClientRect().top<=0) {
    header.classList.remove('sticky_bottom');
    border.classList.remove('border_top');
    border.classList.add('border_bottom');
    header.classList.add('sticky_top');
    if (cookie) {
      cookie.classList.add('active');
    }
  }


  if(window.pageYOffset < firstScreen.getBoundingClientRect().height-header.getBoundingClientRect().height)
  {
    // console.log(team.getBoundingClientRect().top);

    header.classList.remove('sticky_top');
    border.classList.remove('border_bottom');
    border.classList.add('border_top');
    header.classList.add('sticky_bottom');
    if (cookie) {
      cookie.classList.remove('active');
    }

  }

  // console.log(window.pageYOffset, window.innerHeight, $(border).height());
  // if (window.pageYOffset >= (window.innerHeight - $(border).height()-20 )) {
  //   $(border).removeClass('border_top').addClass('border_bottom');
  // }else{
  //   $(border).removeClass('border_bottom').addClass('border_top');
  // }

  // if (window.pageYOffset > sticky) {
  //   if (header.classList.contains('sticky_bottom')) {
  //     header.classList.remove('sticky_bottom');
  //     header.classList.add('sticky_top');
  //   }
  //   if (cookie) {
  //     cookie.classList.add('active');
  //   }
  // } else {
  //   if(header.classList.contains('sticky_top')) {
  //     header.classList.remove('sticky_top');
  //     header.classList.add('sticky_bottom');
  //   }
  //   if (cookie) {
  //     cookie.classList.remove('active');
  //   }
  // }
}




function myFunction2() {


  const header = document.querySelector('.about_plain_team');
  const border = document.querySelector('.about_plain_team_wrap');
  const team = document.querySelector('.about_team');
  const sB2 = document.querySelector('.scrollBottom2');

  // var th = team.getBoundingClientRect().height;
  // var to = team.offsetTop;
  
  if (header.getBoundingClientRect().top<=0) {

    header.classList.remove('sticky_bottom');
    border.classList.remove('border_top');
    border.classList.add('border_bottom');
    header.classList.add('sticky_top');
    sB2.classList.remove('active');

  
  }

  if(team.getBoundingClientRect().top-header.getBoundingClientRect().height>=0)
  {
    // console.log(team.getBoundingClientRect().top);

    header.classList.remove('sticky_top');
    border.classList.remove('border_bottom');
    border.classList.add('border_top');
    header.classList.add('sticky_bottom');
    sB2.classList.add('active');

  }
  //   $(border).removeClass('border_top').addClass('border_bottom');
  // }else{
  //   $(border).removeClass('border_bottom').addClass('border_top');
  // }

  // if (window.pageYOffset > sticky) {
  //   if (header.classList.contains('sticky_bottom')) {
  //     header.classList.remove('sticky_bottom');
  //     header.classList.add('sticky_top');
  //   }
  //   if (cookie) {
  //     cookie.classList.add('active');
  //   }
  // } else {
  //   if(header.classList.contains('sticky_top')) {
  //     header.classList.remove('sticky_top');
  //     header.classList.add('sticky_bottom');
  //   }
  //   if (cookie) {
  //     cookie.classList.remove('active');
  //   }
  // }
}


$('.single_header__tags').clone().appendTo('.single_header_mobile_preimg');
$('.single_header__title').clone().appendTo('.single_header_mobile_preimg');
$('.single_header_tradeshow').clone().appendTo('.single_header_mobile_afterimg');
$('.single_header_location').clone().appendTo('.single_header_mobile_afterimg');



// let modal = $('.modal');

// function modalEmpty() {
//   // $('.modal_title').empty();
//   $('.modal_content').empty();
//   $('.modal_content').removeClass('modal_bg');
//   // $('.modal_buttons').empty();
// }

// function modalClose() {
//   modal.css('opacity','0');
//   // $('.popup_buttons').find('.button').prop('disabled', true).css('pointer-events', 'none');
//   setTimeout(function() {
//     modal.removeAttr('style');
//     modal.removeClass('active');
//     modalEmpty();
//     $('.modal_prev').remove();

//     $('.modal_next').remove();
//     // $('*').css('cursor', 'default');

//     // document.body.style.cursor = 'default';
//   }, 500);
// }

// function modalActive() {
//   modal.addClass('active');
//   // console.log(popuph + ' ' + winh);
// }

// $('body').click(function(e) {
//   if (modal.hasClass('active')&& $(e.target).is('.modal')) {
//     modalClose();
//   };
//   if (modal.hasClass('active')&& $(e.target).is('.modal_body_wrap')) {
//     modalClose();
//   };
// });

// $(document).keyup(function(e) {
//   if (modal.hasClass('active') && (e.keyCode === 27)) {
//     modalClose();
//   }
// });



$(document).on('click', '.action', function(e) {
  // это, чтобы пока котрабатывает скрипт кнопку нельзя было нажать еще раз.
  // $(this).prop('disabled', true).css('pointer-events', 'auto');

  const action = $(this).data('action');

  switch(action) {
    case 'send-form':
      $('.contacts_rs_form').submit(function() {
        e.preventDefault();

        if ($(this)[0].checkValidity()) {

          $.ajax({
            url: 'ajax.html',
            type: 'POST',
            data: {sendForm: $(this).serialize() },
            dataType:'json',
            context: this,
            success(data) {
              $(this)[0].reset();
              modal.empty();
           
              modal.data(data.modaltitle, data.modaldata, data.buttons);
            
              modal.active();

              // modalEmpty();
              
              // if (data.modaldata) { 
              //   $('.modal_content').html('<div class="modal_content_data">'+data.modaldata+'</div>'); 
              // }
              
              // if (data.modaltitle) { 
              //   $('.modal_content').prepend('<div class="modal_title">'+data.modaltitle+'</div>');
              // }
              
              // if (data.buttons) {
              //   var res = '<div class="modal_buttons_inside">';
              //   $.each(data.buttons, function(key, button) {
              //     res += '<button  class="' + button.class + '" type="' + button.type +'" data-action="' + button.action + '" >' + button.title + '</button>';
              //   });
              //   res += '</div>';
              //   $('.modal_content').append('<div class="modal_buttons">'+res+'</div>');  
              // }
              // modalActive();
            },
            beforeSend() {
              $(this).find('.ebtn').prop('disabled', true);
            },
            complete() {
              $(this).find('.ebtn').prop('disabled', false);

            }
          });
        }
      });  
      break;
    case 'request-form':
      e.preventDefault();
      $.ajax({
        url: 'ajax.html',
        type: 'POST',
        data: {requestForm: true },
        dataType:'json',
        context: this,
        success(data) {
          modal.empty();
           
          modal.data(data.modaltitle, data.modaldata, data.buttons);
        
          modal.active();
          // modalEmpty();
          // if (data.modaldata) { 
          //   $('.modal_content').html('<div class="modal_content_data">'+data.modaldata+'</div>'); 
          // }
          // if (data.modaltitle) { $('.modal_content').prepend(
          //   '<div class="modal_title">'+data.modaltitle+'</div>'
          // );}

          // if (data.buttons) {
          //   var res = '<div class="modal_buttons_inside">';
          //   $.each(data.buttons, function(key, button) {
          //     res += '<button  class="' + button.class + '" type="' + button.type +'" data-action="' + button.action + '" >' + button.title + '</button>';
          //   });
          //   res += '</div>';
          //   $('.modal_content').append(
          //     '<div class="modal_buttons">'
          //     +res+
          //     '</div>');  
          // }
          // modalActive();
        },
        beforeSend() {
          $(this).find('.button').prop('disabled', true);
        },
        complete() {
          $(this).find('.button').prop('disabled', false);
        }
      });
      break;


    case 'cookie-ok':
      e.preventDefault();
      $.ajax({
        url: 'ajax.html',
        type: 'POST',
        data: {cookieOk: true },
        // dataType:'json',
        // context: this,
        success() {
          cookieClose();       
        }
      });
      break;

    // case 'modal-close':
    //   e.preventDefault();
    //   modalClose();
    //   break;

    case 'cookie-close':
      e.preventDefault();
      cookieClose();
      break;
    default:
      console.log('nothing to do');
  }// end of switch

});



const singleBack = document.querySelectorAll('.single_header__back')[0];

if (singleBack) {
  singleBack.addEventListener('click', function(e) {
    e.preventDefault();
    if(document.referrer.indexOf(window.location.hostname) >= 0) {
      window.history.back();
    }
    else {
      window.location.href = 'portfolio/';
    }
  });  
}


const sT = document.querySelectorAll('.scrollTop')[0];
const $sB = $('.scrollBottom');
// var sB2 = document.querySelectorAll('.scrollBottom2')[0];
// var sB3 = document.querySelectorAll('.scrollBottom3')[0];



window.onscroll = function() {
  const s = window.pageYOffset || document.documentElement.scrollTop;
  const h = window.innerHeight;
  if (s>h) {
    sT.classList.add('active');
  }else{
    sT.classList.remove('active');
  }
  if (single) {
    myFunction();
  }
  if (aboutus) {
    
    // myFunction2();
  }
};

if ($sB) {
  $sB.on('click', function(e) {
    e.preventDefault();

    // console.log(this.dataset.scroll);
    
    $('html, body').animate({ scrollTop: $(`.${this.dataset.scroll}`).offset().top }, 600);

    // scrollPageTo(h);
    // window.scrollTo({
    //   top: h,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  });
}

// if (sB2) {
//   sB2.addEventListener('click', function(e) {
//     e.preventDefault();
//     var h = window.innerHeight*2;
//     $('html, body').animate({ scrollTop: h }, 600);
//     // scrollPageTo(h);

//     // window.scrollTo({
//     //   top: h,
//     //   left: 0,
//     //   behavior: 'smooth'
//     // });
//   });
// }

// if (sB3) {
//   sB3.addEventListener('click', function(e) {
//     e.preventDefault();
//     var h = window.innerHeight*3;
//     $('html, body').animate({ scrollTop: h }, 600);
//     // scrollPageTo(h);

//     // window.scrollTo({
//     //   top: h,
//     //   left: 0,
//     //   behavior: 'smooth'
//     // });
//   });
// }

if (sT) {
  sT.addEventListener('click', function(e) {
    e.preventDefault();
    // scrollPageTo(0);
    $('html, body').animate({ scrollTop: 0 }, 600);

    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  });   
}



// function scrollPageTo(to, duration=500) {
//   // t = current time
//   // b = start value
//   // c = change in value
//   // d = duration
//   const easeInOutQuad = function(t, b, c, d) {

//     t /= d/2;
//     if (t < 1) return c/2*t*t + b;
//     t -=1;
//     return -c/2 * (t*(t-2) - 1) + b;
//   };

//   return new Promise((resolve, reject) => {
//     const element = document.scrollingElement;

//     if (typeof to === 'string') {
//       to = document.querySelector(to) || reject();
//     }
//     if (typeof to !== 'number') {
//       to = to.getBoundingClientRect().top + element.scrollTop;
//     }

//     const start = element.scrollTop;
//       const change = to - start;
//       let currentTime = 0;
//       const increment = 20;

//     const animateScroll = function() {
//       currentTime += increment;
//       const val = easeInOutQuad(currentTime, start, change, duration);
//       element.scrollTop = val;
//       if(currentTime < duration) {
//         setTimeout(animateScroll, increment);
//       } else {
//         resolve();
//       }
//     };
//     animateScroll();
//   });
// }
 

document.querySelectorAll('.weAreItemContent').forEach(item => {
  item.addEventListener('click', (e) => {
    e.preventDefault();

    // console.log(e.target.nextElementSibling);

if(e.target.nextElementSibling.innerHTML) {
  const modal2 = new Modal2(e.target.nextElementSibling.innerHTML);
  modal2.active();

}
     // try {
    //   e.target.nextElementSibling.classList.add('is-active');
      
    //   e.target.nextElementSibling.addEventListener('click', () => {
    //     console.log(e.target)
    //     e.target.classList.remove('is-active');
    //   })


    // } catch (error) {
      
    // eslint-disable-next-line no-undef
    // }console.log(error)
  })
})

